// extracted by mini-css-extract-plugin
export default {"table":"DynamicTable_table__FxYzW","img":"DynamicTable_img__Enow3"};